import { useNavigate } from 'react-router-dom';
import { Box, IconButton } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { TOPO_LOGO_HEIGHT } from 'theme';
import logoFull from 'assets/images/logo.png';
import logoMark from 'assets/images/square_logo.svg';

function DrawerTop({ collapsed = false, onToggle }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'relative',
        height: TOPO_LOGO_HEIGHT,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#ffffff',
      }}
    >
      <Box
        onClick={() => navigate('/')}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          px: collapsed ? 0 : 2,
          boxSizing: 'border-box',
        }}
      >
        <img
          alt='logo'
          src={logoFull}
          style={{
            width: '100%',
            height: 'auto',
            display: collapsed ? 'none' : 'block',
          }}
        />
        <img
          alt='logo'
          src={logoMark}
          style={{
            width: '40px',
            height: 'auto',
            marginTop: '40px',
            display: collapsed ? 'block' : 'none',
          }}
        />
      </Box>

      {onToggle && (
        <IconButton
          aria-label={collapsed ? 'expandir menu' : 'recolher menu'}
          onClick={onToggle}
          size='small'
          sx={{
            position: 'absolute',
            top: 16,
            width: 20,
            height: 20,
            color: collapsed ? '#3E3E3E' : '#343A40',
            ...(collapsed
              ? { left: '50%', transform: 'translateX(-50%)' }
              : { right: 8 }),
          }}
        >
          <MenuIcon sx={{ fontSize: 20 }} />
        </IconButton>
      )}
    </Box>
  );
}
export default DrawerTop;
